import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import loaderGif from "../../assets/loader.gif";
import { useNavigate } from "react-router-dom";
import { MdOutlineDateRange } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { basicauthblog } from "../../basicauth";
import { User } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DefaultBlog from "../../assets/DefaultBlog.png"
// import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";

const AuthorImage = ({ image, name, size = "h-7 w-7" }) => {
  const [imageError, setImageError] = useState(false);

  if (!image || imageError) {
    return (
      <div
        className={`flex ${size} shrink-0 items-center justify-center rounded-full bg-white`}
      >
        <User size={18} strokeWidth={2} className="text-gray-500" />
      </div>
    );
  }

  return (
    <img
      src={image}
      alt={name || "Author"}
      className={`${size} shrink-0 rounded-full object-cover`}
      onError={() => setImageError(true)}
    />
  );
};

const Article = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [blogData, setBlogData] = useState(null);
  const [postdata, setpostdata] = useState([]);
  const { post_slug } = useParams();
  console.log("Post Slug from URL:", post_slug);

  useEffect(() => {
    console.log(post_slug); 
    if (post_slug) {
      GetAuthorsBlog(post_slug);
    }
  }, [post_slug]);

  const { password, username } = basicauthblog;
    const base64Credentials = btoa(`${username}:${password}`);

  const GetAuthorsBlog = async (slug) => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
       headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ slug: slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        setBlogData(data.data[0]);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
       headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({
          webid: "6",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (blogData) {
      const images = document.querySelectorAll(".blog-content img");
      images.forEach((img) => {
        img.style.borderRadius = "1rem";
        img.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
        img.style.width = "100%";
        img.style.height = "auto";
      });
    }
  }, [blogData]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  if (!blogData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
      </div>
    );
  }
  function cleanBlockContent(htmlString) {
    return htmlString.replace(/<\/?span[^>]*>/g, "");
  }

  return (
    <>
      <Helmet>
        <script src="https://seobix.com/schemaScript/jsonpackky.js"></script>
      </Helmet>

      <Navbar />

      <main className="w-full pt-20 bg-gray-100 sm:pt-24 pb-8">
        <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            {/* LEFT ARTICLE */}
            <article className="w-full lg:col-span-9">
              <div className="w-full">
                <h1 className="text-2xl mt-7 font-semibold leading-tight text-gray-900 sm:text-3xl md:text-4xl lg:text-4xl">
                  {blogData.title}
                </h1>

                {/* Author + Date */}
                <div className="mt-4 flex items-center justify-between gap-3">
                  {/* Author */}
                  <div className="flex min-w-0 items-center text-sm text-gray-700">
                    <AuthorImage
                      image={blogData.author_url}
                      name={blogData.author_name}
                      size="h-7 w-7"
                    />

                    <button
                      type="button"
                      onClick={() => {
                        const authorData = JSON.stringify(blogData);
                        localStorage.setItem("author", authorData);
                        navigate(`/author/${blogData.author_slug}`);
                      }}
                      className="ml-2 truncate text-left hover:text-blue-600"
                    >
                      {blogData.author_name}
                    </button>
                  </div>

                  {/* Date */}
                  <div className="flex shrink-0 items-center text-sm text-gray-600">
                    <MdOutlineDateRange className="mr-1 text-xl text-gray-500" />

                    {blogData.in_time && (
                      <span>
                        {new Date(
                          blogData.in_time.replace(" ", "T"),
                        ).toLocaleDateString("en-GB")}
                      </span>
                    )}
                  </div>
                </div>

                {/* Main Image */}
                <div className="mt-6 overflow-hidden rounded-2xl">
                  <img
                    src={blogData.image_url}
                    alt={blogData.image_desc}
                    title={blogData.image_desc}
                    className="h-auto w-full rounded-2xl object-cover"
                  />
                </div>

                <p className="mt-5 text-base leading-7 text-gray-700 sm:text-[16px]">
                  {blogData.excerpt}
                </p>

                {/* Blog Content */}
                <div className="blog-content mt-6 max-w-none text-[15px] leading-7 text-gray-800 sm:text-sm">
                  <style>
                    {`
                    .blog-content a {
                      text-decoration: none;
                      color: #2563eb;
                      word-break: break-word;
                    }

                    .blog-content a:hover {
                      text-decoration: underline;
                    }

                    .blog-content img {
                      width: 100%;
                      height: auto;
                      border-radius: 1rem;
                      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    }

                    .blog-content h1 {
                      font-size: clamp(1.8rem, 4vw, 2.8rem);
                      font-weight: 700;
                      line-height: 1.2;
                      margin: 1.5rem 0 1rem;
                    }

                    .blog-content h2 {
                      font-size: clamp(1.5rem, 3vw, 2.2rem);
                      font-weight: 500;
                      line-height: 1.3;
                      margin: 1.4rem 0 0.8rem;
                    }

                    .blog-content h3 {
                      font-size: clamp(1.25rem, 2.5vw, 1.7rem);
                      font-weight: 600;
                      margin: 1.2rem 0 0.7rem;
                    }

                    .blog-content p {
                      margin-bottom: 1rem;
                    }

                    .blog-content ul,
                    .blog-content ol {
                      padding-left: 1.5rem;
                      margin-bottom: 1rem;
                    }

                    .blog-content li {
                      margin-bottom: 0.5rem;
                    }

                    .blog-content table {
                      width: 100%;
                      display: block;
                      overflow-x: auto;
                    }

                    .blog-content pre {
                      overflow-x: auto;
                      padding: 1rem;
                      border-radius: 0.75rem;
                      background: #f3f4f6;
                    }
                  `}
                  </style>

                  {(() => {
                    const renderedContents = new Set();

                    return blogData.blocks?.map((block, index) => {
                      const cleanedContent = cleanBlockContent(
                        block.block_content,
                      );
                      const type = block.block_type.toLowerCase();

                      if ((type === "ul" || type === "ol") && cleanedContent) {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = cleanedContent;
                        const paragraphs = Array.from(
                          tempDiv.querySelectorAll("p"),
                        );
                        paragraphs.forEach((p) =>
                          renderedContents.add(p.innerHTML.trim()),
                        );
                      }

                      if (
                        type === "p" &&
                        renderedContents.has(cleanedContent.trim())
                      ) {
                        return null;
                      }

                      const supportedTags = [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "p",
                        "ul",
                        "ol",
                        "li",
                        "blockquote",
                        "code",
                        "pre",
                        "div",
                        "span",
                        "strong",
                        "em",
                        "u",
                        "img",
                        "video",
                        "a",
                        "br",
                      ];

                      if (
                        (type === "p" || type.startsWith("h")) &&
                        cleanedContent.includes("<img") &&
                        blogData.blocks[index + 1]?.block_type.toLowerCase() ===
                          "img"
                      ) {
                        const nextImg = blogData.blocks[index + 1].block_image;
                        const match = cleanedContent.match(
                          /<img[^>]+src="([^"]+)"/i,
                        );
                        if (match && match[1] === nextImg) return null;
                      }

                      if (type === "img" && block.block_image) {
                        return (
                          <div key={index} className="my-5 text-center">
                            <img
                              src={block.block_image}
                              alt={block.block_image_alt || ""}
                              title={block.block_image_title || ""}
                              className="mx-auto h-auto w-full rounded-2xl object-cover"
                            />
                            {block.block_image_desc && (
                              <p className="mt-2 text-sm text-gray-500">
                                {block.block_image_desc}
                              </p>
                            )}
                          </div>
                        );
                      }

                      if (supportedTags.includes(type)) {
                        return (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{
                              __html: `<${type}>${cleanedContent}</${type}>`,
                            }}
                          />
                        );
                      }

                      return (
                        <p
                          key={index}
                          dangerouslySetInnerHTML={{ __html: cleanedContent }}
                        />
                      );
                    });
                  })()}
                </div>

                {/* Keywords */}
                <div className="mt-6 flex flex-wrap gap-2">
                  {[...(blogData.keyword || "").split(",")].map(
                    (keyword, index) =>
                      keyword.trim() && (
                        <span
                          key={index}
                          className="rounded border border-gray-300 bg-gray-100 px-3 py-1 text-xs text-gray-700 sm:text-sm"
                        >
                          {keyword.trim()}
                        </span>
                      ),
                  )}
                </div>

                {/* Tags */}
                <div className="mt-4 flex flex-wrap gap-2 pb-8">
                  {(blogData.tag || "")
                    .split(",")
                    .filter((tag) => tag.trim())
                    .map((tag, index) => (
                      <button
                        key={index}
                        type="button"
                        onClick={() => {
                          sessionStorage.setItem(
                            "tag",
                            JSON.stringify(tag.trim()),
                          );
                          sessionStorage.setItem("FromTag", "1");
                          navigate("/blog-section");
                        }}
                        className="text-sm text-blue-600 hover:underline"
                      >
                        #{tag.trim()}
                      </button>
                    ))}
                </div>
              </div>
            </article>

            {/* RIGHT RELATED BLOGS */}
            <aside className="w-full lg:col-span-3">
              <div className="sticky top-24">
                <h6 className="mb-5 text-center text-lg font-semibold text-gray-900 lg:text-left">
                  Related Blogs
                </h6>

                <div className="related-blogs-scroll max-h-[500px] space-y-4 overflow-y-auto pr-1 lg:max-h-[100vh]">
                  {postdata.map((blog) => (
                    <div
                      key={blog.id}
                      className="flex w-full items-center gap-3"
                    >
                      <img
                        src={blog.image_url}
                        alt={blog.image_alt || "Blog Image"}
                        className="h-[60px] w-[60px] flex-shrink-0 rounded-lg object-cover"
                      />

                      <a
                        href={`/blog/${blog.slug}`}
                        onClick={() => {
                          sessionStorage.setItem("Slug", JSON.stringify(blog));
                        }}
                        className="min-w-0 flex-1 text-inherit no-underline"
                      >
                        <p className="truncate text-sm font-medium text-black">
                          {blog.title}
                        </p>

                        <p className="mt-1 flex items-center text-xs font-semibold text-gray-500">
                          <AuthorImage
                            image={blog.author_image}
                            name={blog.author_name}
                            size="h-[18px] w-[18px]"
                          />
                          <span className="truncate ml-2">
                            {blog.author_name}
                          </span>
                        </p>
                      </a>
                    </div>
                  ))}
                </div>

                <style>
                  {`
                  .related-blogs-scroll::-webkit-scrollbar {
                    display: none;
                  }
                  .related-blogs-scroll {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                  }
                `}
                </style>
              </div>
            </aside>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Article;